export type Response<T> = { status: number; message: string; data: T };

export default function getResponseData<T>({ status, message, data }: Response<T>): T {
    if (status === 419 || status === 401) {
        throw new Error(message);
    }

    return data;
}
